import {ChangeDetectorRef, Component} from '@angular/core';
import {ClaimList} from "../claim-list/claim-list";
import {ClaimOverviewStatistics} from "../claim-overview-statistics/claim-overview-statistics";
import {ClaimSearchForm} from "../claim-search-form/claim-search-form";
import {MatProgressSpinner} from "@angular/material/progress-spinner";
import {ClaimListResponse} from '../../entity/claim-list-response';
import {ClaimItem} from '../../entity/claim-item';
import {ClaimListService} from '../../control/claim-list-service';
import {PageEvent} from '@angular/material/paginator';
import {SelectedYearProvider} from '../../control/selected-year-provider';
import {LocalizationPipePipe} from '../../../localization/control/localisation-pipe-pipe';
import {YearSelector} from '../year-selector/year-selector';

@Component({
  selector: 'app-claim-search',
  imports: [
    ClaimList,
    ClaimOverviewStatistics,
    ClaimSearchForm,
    MatProgressSpinner,
    LocalizationPipePipe,
    YearSelector
  ],
  templateUrl: './claim-search.html',
  styleUrl: './claim-search.scss'
})
export class ClaimSearch {
  protected isLoading: boolean = false;
  protected isDownloading: boolean = false;
  protected claimListResponse: ClaimListResponse = {claims: [], lastEvaluatedKey: ""};
  protected claimList: ClaimItem[] = []
  protected pageSize: number = 10000;
  private insuranceClaimReference: string = '';


  constructor(
    private readonly claimService: ClaimListService,
    private readonly selectedYearProvider: SelectedYearProvider,
    private readonly cdr: ChangeDetectorRef) {
  }

  onPageChange($event: PageEvent) {
    // Calculate if we're on the last page
    const currentPage = $event.pageIndex;
    const pageSize = $event.pageSize;
    const totalLength = $event.length;
    const isLastPage = (currentPage + 1) * pageSize >= totalLength;
    const hasMoreData = this.claimListResponse.lastEvaluatedKey !== "";

    if (isLastPage && hasMoreData) {
      this.searchClaims();
    }
  }

  searchByInsuranceClaimReference(insuranceClaimReference: string) {
    this.insuranceClaimReference = insuranceClaimReference;
    this.searchClaims();
  }

  private searchClaims() {
    let keyword = (this.insuranceClaimReference ?? '').toString();
    if (keyword.trim().length === 0) {
      return;
    }
    this.isLoading = true;
    this.claimService.searchClaims(
      this.insuranceClaimReference,
      this.selectedYearProvider.year,
      this.pageSize,
      this.claimListResponse.lastEvaluatedKey
    )
      .then(r => {
        this.isLoading = false;
        this.claimListResponse = r;
        this.claimList = r.claims;
        this.cdr.detectChanges();
      })
      .catch(error => {
        this.isLoading = false;
        console.log(`Error searching by insurance claim reference: ${this.insuranceClaimReference}`, error)
        this.claimListResponse = {claims: [], lastEvaluatedKey: ""};
        this.claimList = [];
        this.cdr.detectChanges();
      })
      .finally(() => {
        this.isLoading = false;
      });
  }

  cancelSearchByInsuranceClaimReference() {
    this.insuranceClaimReference = '';
    this.claimList = []
    this.claimListResponse = {claims: [], lastEvaluatedKey: ""};
  }

  protected onExportClaims() {
    this.isDownloading = true
    this.claimService.downloadClaims(this.insuranceClaimReference)
      .then(r => {
        console.log({r})
        this.downloadFile(r.downloadUrl, `batch-download-${this.insuranceClaimReference}.zip`)
      })
      .catch(error => {
        console.error('Error downloading claims:', error);
        alert(`Error downloading claims: ${error}`)
      })
      .finally(() => {
        this.isDownloading = false
        this.cdr.detectChanges();
      })
  }

  private downloadFile(url: string, fileName: string): void {
    try {
      const anchor = document.createElement('a');
      anchor.href = url;
      anchor.download = fileName;
      anchor.target = '_blank';
      anchor.style.display = 'none';

      document.body.appendChild(anchor);
      anchor.click();
      document.body.removeChild(anchor);
    } catch (error) {
      console.error(`Failed to download file ${fileName}:`, error);
    }
  }
}
